import {
  BrowserRouter,
  Routes as RouterRoutes,
  Route,
  Navigate,
} from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import ErrorBoundary from "./components/ErrorBoundary";
import NotFound from "./pages/NotFound";
import LandingPage from "./pages/landing-page";
// import MentalNeuroSection from "./pages/mental-neuro-section";
// import NutritionHub from "./pages/nutrition-hub";
// import VideoLibrary from "./pages/video-library";
// // import AssessmentQuestionnaire from "./pages/assessment-questionnaire";
import AuthCallback from "./pages/auth/callback";
// import PaymentPage from "./pages/payment";
// import PaymentSuccess from "./pages/payment/success";
// import PaymentCancel from "./pages/payment/cancel";
// import Dashboard from "./pages/dashboard";
// import PrivacyPolicy from "./pages/privacy-policy";
// import TermsOfService from "./pages/terms-of-service";
// import CookiePolicy from "./pages/cookie-policy";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import BookACall from "./pages/book-a-call";
import { AdminDashboard } from "./pages/admin/dashboard";
import { AdminUsers } from "./pages/admin/users";
import { AdminMessages } from "./pages/admin/messages";
import { AdminTrainingRoutines } from "./pages/admin/users/training-routines";

// interface ProtectedRouteProps {
//   element: React.ReactElement;
//   requireAuth?: boolean;
//   requirePayment?: boolean;
// }

// const ProtectedRouteComponent = ({
//   element,
//   requireAuth = false,
//   requirePayment = false,
// }: ProtectedRouteProps) => {
//   const { isAuthenticated, hasPaid } = useAuth();

//   if (requirePayment && (!isAuthenticated || !hasPaid)) {
//     return <Navigate to="/" replace />;
//   }

//   if (requireAuth && !isAuthenticated) {
//     return <Navigate to="/" replace />;
//   }

//   return element;
// };

const Routes = () => {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ErrorBoundary>
          <ScrollToTop />
          <RouterRoutes>
            {/* Public Routes */}
            <Route path="/" element={<LandingPage />} />
            <Route path="/landing-page" element={<LandingPage />} />
            {/* <Route path="/assessment" element={<AssessmentQuestionnaire />} /> */}
            {/* <Route
              path="/assessment-questionnaire"
              element={<AssessmentQuestionnaire />}
            /> */}
            <Route path="/book-a-call" element={<BookACall />} />

            {/* Auth Routes */}
            <Route path="/auth/callback" element={<AuthCallback />} />

            {/* Payment Routes 
            <Route
              path="/payment"
              element={
                <ProtectedRouteComponent
                  element={<PaymentPage />}
                  requireAuth
                />
              }
            />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />

            <Route
              path="/dashboard"
              element={
                <ProtectedRouteComponent
                  element={<Dashboard />}
                  requirePayment
                />
              }
            />
            <Route
              path="/mental-wellness"
              element={
                <ProtectedRouteComponent
                  element={<MentalNeuroSection />}
                  requirePayment
                />
              }
            />
            <Route
              path="/mental-neuro-section"
              element={
                <ProtectedRouteComponent
                  element={<MentalNeuroSection />}
                  requirePayment
                />
              }
            />
            <Route
              path="/nutrition"
              element={
                <ProtectedRouteComponent
                  element={<NutritionHub />}
                  requirePayment
                />
              }
            />
            <Route
              path="/nutrition-hub"
              element={
                <ProtectedRouteComponent
                  element={<NutritionHub />}
                  requirePayment
                />
              }
            />
            <Route
              path="/video-library"
              element={
                <ProtectedRouteComponent
                  element={<VideoLibrary />}
                  requirePayment
                />
              }
            />

            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/cookie-policy" element={<CookiePolicy />} />

            {/** Admin Routes */}
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/users" element={<AdminUsers />} />
            <Route
              path="/admin/users/training-routines"
              element={<AdminTrainingRoutines />}
            />
            <Route path="/admin/messages" element={<AdminMessages />} />

            {/* 404 */}
            <Route path="*" element={<NotFound />} />
          </RouterRoutes>
        </ErrorBoundary>
      </BrowserRouter>
    </AuthProvider>
  );
};

export default Routes;
